// Central branding constants — override via environment variables
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'RISQ Master Hub';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'sara@bluehorizonsolutions.net';
// If set, shows a "PSC Platform" shortcut button in the dashboard header
export const PSC_URL = process.env.REACT_APP_PSC_URL || '';
